'use client';

import { useState } from 'react';
import { Search, Image as ImageIcon, Film, Upload, Grid, List } from 'lucide-react';
import { usePersistedState } from '@/lib/usePersistedState';

export default function AssetsPage() {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = usePersistedState<'all' | 'image' | 'video'>('content:assets-filter', 'all');
  const [viewMode, setViewMode] = usePersistedState<'grid' | 'list'>('content:assets-view', 'grid');

  // TODO: fetch from /api/content/media when wired up
  const assets: { id: string; name: string; type: 'image' | 'video'; url?: string }[] = [];

  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <h1 className="text-xl font-semibold text-white">Asset Library</h1>
        <p className="text-sm text-gray-500 mt-1">Images and videos for your content</p>
      </div>

      <div className="flex items-center gap-3 flex-wrap">
        <div className="relative flex-1 min-w-[200px] max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search assets..."
            className="w-full pl-10 pr-4 py-2 rounded-lg bg-white/[0.05] border border-white/[0.08] text-sm text-white placeholder-gray-600 focus:outline-none focus:border-cyan-500/50" />
        </div>
        <div className="flex gap-1 bg-white/[0.05] rounded-lg p-1">
          {(['all', 'image', 'video'] as const).map(f => (
            <button key={f} onClick={() => setFilter(f)}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all ${filter === f ? 'bg-cyan-500/20 text-cyan-400' : 'text-gray-400 hover:text-white'}`}>
              {f === 'all' ? 'All' : f === 'image' ? 'Images' : 'Videos'}
            </button>
          ))}
        </div>
        <div className="flex gap-1 bg-white/[0.05] rounded-lg p-1">
          <button onClick={() => setViewMode('grid')} className={`p-1.5 rounded-md ${viewMode === 'grid' ? 'bg-gray-800 text-white' : 'text-gray-500'}`}><Grid className="h-4 w-4" /></button>
          <button onClick={() => setViewMode('list')} className={`p-1.5 rounded-md ${viewMode === 'list' ? 'bg-gray-800 text-white' : 'text-gray-500'}`}><List className="h-4 w-4" /></button>
        </div>
      </div>

      <div className="text-center py-20 rounded-xl border border-dashed border-white/[0.08]">
        <Upload className="w-10 h-10 text-gray-700 mx-auto mb-3" />
        <p className="text-gray-500 text-sm">No assets yet</p>
        <p className="text-xs text-gray-600 mt-1">Assets uploaded through content creation will appear here</p>
      </div>
    </div>
  );
}
